import { Helper } from "../util/helper.js";
import { Config } from "../config/config.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react"
export class DateTimePicker extends React.Component<DateTimePickerProps, any>{
    private dateTimePickerRef: any;
    private dateTimePicker: kendo.ui.DateTimePicker;
    private value: any;
    private disabled = true;
    private timeZone: string = "";
    private timeZoneInfoText: string = "User time: {time}";

    constructor(props: DateTimePickerProps) {
        super(props)
        this.setTimeZone();
    }

    componentWillUnmount() {
        this.dateTimePicker.destroy();
    }
    public getDateTimePickerRef = () => {
        return this.dateTimePicker;
    }
    componentDidMount() {
        this.disabled = this.props.disabled || false;
        this.value = this.props.value;
        this.dateTimePicker = $(this.dateTimePickerRef).kendoDateTimePicker({
            parseFormats: ['yyyy-MM-ddTHH:mm:ss', 'yyyy-MM-dd HH:mm:ss', 'MM/dd/yyyy HH:mm', 'dd.MM.yyyy HH:mm', 'yyyy-MM-dd', 'MM/dd/yyyy', 'dd.MM.yyyy'],
            value: this.value,
            weekNumber: true,
            change: (ev) => {
                this.value = ev.sender.value();
                this.props.onChange(this.props.field, Helper.dates.getISODateString(this.value), null);
            }
        }).data("kendoDateTimePicker");
        this.dateTimePicker.readonly(this.disabled);
        this.dateTimePicker.wrapper.attr("data-readonly", this.disabled.toString());
        if (this.props.field.focus)
            this.dateTimePicker.element.focus();
        Helper.getTranslations(["Standard.UserTime"])
            .then((result) => {
                this.timeZoneInfoText = result.Data["Standard.UserTime"];
                this.setState({});
            });
    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this.disabled !== isDisabled) {
            this.disabled = isDisabled;
            this.dateTimePicker.readonly(this.disabled);
            this.dateTimePicker.wrapper.attr("data-readonly", this.disabled.toString());
        }
        if (Helper.dates.compareMultiTypeDates(this.value, this.props.value, false) !== 0) {
            if (this.props.value !== this.value) {
                this.setState({});
            }
            this.value = this.props.value;
            this.dateTimePicker.value(this.value);
        }

    }



    private createLabel = () => {
        const divStyle: React.CSSProperties = {
            fontSize: "11px",
            marginTop: "2px",
            width: "90%",
            color: "#1e88e5"
        };
        const text = this.timeZoneInfoText.replace("{time}", this.getLocalDateTime());
        return (
            <>
                <div style={divStyle}>
                    {text}
                </div>
            </>
        );
    }

    private getLocalDateTime = () => {
        let value = Helper.dates.getISODateString(moment(this.value).tz(this.timeZone, true).tz(Config.user.timezoneIANA).toISOString(true));
        let date = kendo.toString(kendo.parseDate(value), 'd');
        return (date + " " + value.substr(11, 5));
    }

    private setTimeZone = () => {

        if (Helper.isNullOrEmpty(this.props.timeZone)) {
            this.timeZone = this.props.handleEval(this.props.field.timeZone);
        } else {
            this.timeZone = this.props.timeZone;
        }

        if (Helper.isNullOrEmpty(this.timeZone) || this.timeZone == Config.user.timezoneIANA) {
            this.timeZone = null;
        } else {
            let date1 = moment(this.value).tz(this.timeZone, true).toISOString(true);
            let date2 = moment(this.value).tz(this.timeZone, true).tz(Config.user.timezoneIANA).toISOString(true);
            if ((date1 === date2)) {
                this.timeZone = null;
            }
        }
    }

    render() {
        this.setTimeZone();
        return (
            <div>
                <input ref={(r) => this.dateTimePickerRef = r} name={this.props.field.model} style={{ width: "100%" }} required={this.props.required} data-label={this.props.field.name} />
                {!Helper.isNullOrEmpty(this.timeZone) && Helper.hasValue(this.value) ? this.createLabel() : null}
            </div>
        );
    }
}

export interface DateTimePickerProps extends BaseComponentProps {
    field: DateTimePickerField;
    handleEval(action: string, prepare?: any);
    timeZone?: string;
}

export interface DateTimePickerField extends BaseField {
    focus?: boolean;
    timeZone?: string;
}